"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  getByName: function getByName(name) {
    return request.quickPost("blocks/info/name/".concat(name), {});
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXRCeU5hbWUiLCJuYW1lIiwicmVxdWVzdCIsInF1aWNrUG9zdCIsImNvbmNhdCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjL2NsaWVudC9tb2R1bGVzL0NvbnRlbnQvQmxvY2svQmxvY2tBY3Rpb25zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcclxuICAgIGdldEJ5TmFtZTogKG5hbWUpID0+IHJlcXVlc3QucXVpY2tQb3N0KGBibG9ja3MvaW5mby9uYW1lLyR7bmFtZX1gLCB7fSksXHJcbn1cclxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7b0NBQWU7RUFDWEEsU0FBUyxFQUFFLFNBQVhBLFNBQVNBLENBQUdDLElBQUk7SUFBQSxPQUFLQyxPQUFPLENBQUNDLFNBQVMscUJBQUFDLE1BQUEsQ0FBcUJILElBQUksR0FBSSxDQUFDLENBQUMsQ0FBQztFQUFBO0FBQzFFLENBQUMifQ==